import Vue from "vue";
import VueRouter from "vue-router";
import Tutorial from "@/views/Tutorial.vue";
import HomePageView from "@/views/HomePageView.vue";

Vue.use(VueRouter);

const routes = [
  { path: "/", name: "HomePageView", component: HomePageView },
  { path: "/tutorial", name: "TutorialPage", component: Tutorial },
];

const router = new VueRouter({
  mode: "hash",
  // mode: "history",   
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return new Promise((resolve) => {
        setTimeout(() => {
          const el = document.querySelector(to.hash);
          if (el) {
            el.scrollIntoView({ behavior: "smooth" });
          }
          resolve(false);
        }, 300);
      });
    }
    return { x: 0, y: 0 };
  }
});

// Override push globally
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name === 'NavigationDuplicated') {
      return this.currentRoute;
    }
    throw err;
  });
};

router.afterEach((to) => {
  document.title = to.meta.title||"MedLab";
});
export default router;



